/*
 * Copyright (C) 2025.  SimpliCity Digital Inc - All Rights Reserved
 */

export const webpageState = {
    webpage: null,
    model: null,
    bannerImage: null,
};
